import axios from "axios";
import React, { useEffect, useState } from "react";
import { fetchCourses } from "../../../api/Evaluation";

export default function CourseManager() {
  const [showModal, setShowModal] = useState(false);
  const [Courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [form, setForm] = useState({
    name: "",
    author_name: "",
    current_price: "",
    regular_price: "",
    course_details: "",
    course_category_id: "",
    content: [{ title: "", items: [] }],
    content_outline: [{ icon: "", text: "" }],
    content_outcome: [""],
    course_intructor: [{ image: null, name: "", education: "" }],
    description: [""],
	seo_description: '',
    status: 1,
  });

  const [image, setImage] = useState(null);
  const [imageGallery, setImageGallery] = useState([]);

  // Handle basic inputs
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle content section
  const handleContentChange = (index, field, value) => {
    const updated = [...form.content];
    updated[index][field] = value;
    setForm({ ...form, content: updated });
  };

  const handleContentItemChange = (sectionIndex, itemIndex, value) => {
    const updated = [...form.content];
    updated[sectionIndex].items[itemIndex] = value;
    setForm({ ...form, content: updated });
  };

  // Handle content outline
  const handleOutlineChange = (index, field, value) => {
    const updated = [...form.content_outline];
    updated[index][field] = value;
    setForm({ ...form, content_outline: updated });
  };

  // Handle content outcome
  const handleOutcomeChange = (index, value) => {
    const updated = [...form.content_outcome];
    updated[index] = value;
    setForm({ ...form, content_outcome: updated });
  };

  // Handle instructor info
  const handleInstructorChange = (index, field, value) => {
    const updated = [...form.course_intructor];
    updated[index][field] = value;
    setForm({ ...form, course_intructor: updated });
  };

  // Submit handler
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true); // ✅ start loading

  const formData = new FormData();

  formData.append("name", form.name);
  formData.append("author_name", form.author_name);
  formData.append("current_price", form.current_price);
  formData.append("regular_price", form.regular_price);
  formData.append("course_category_id", form.course_category_id);
  formData.append("course_details", form.course_details);
  formData.append("status", form.status);
  formData.append("seo_description", form.seo_description);

  if (image) formData.append("image", image);

  imageGallery.forEach((file, index) => {
    formData.append(`image_gallery[${index}]`, file);
  });

  const instructorData = form.course_intructor.map((inst, i) => {
    if (inst.image) {
      formData.append(`instructor_images[${i}]`, inst.image);
    }
    return {
      name: inst.name,
      education: inst.education,
      image: null,
    };
  });

  formData.append("content", JSON.stringify(form.content));
  formData.append("content_outcome", JSON.stringify(form.content_outcome));
  formData.append("content_outline", JSON.stringify(form.content_outline));
  formData.append("course_intructor", JSON.stringify(instructorData));
  formData.append("description", JSON.stringify(form.description));

  try {
    const res = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/courses`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("✅ Course created:", res.data);
    setShowModal(false); // close modal
    loadCourses(); // refresh list
  } catch (error) {
    console.error("❌ Submission error:", error.response?.data?.errors || error.message);
    alert("Course submission failed.");
  } finally {
    setIsSubmitting(false); // ✅ stop loading
  }
};




//get data
const loadCourses = async () => {
  try {
    const data = await fetchCourses(); 
    setCourses(data);
  } catch (error) {
    console.error("❌ Error fetching courses:", error);
  } finally {
    setLoadingCourses(false);
  }
};



  useEffect(() => {
   

    loadCourses();
  }, []);


    const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this courses?"
    );
    if (!confirmDelete) return;

    try {
     

      await axios.delete(`${import.meta.env.VITE_API_BASE_URL}/api/courses/${id}`);

      // Refresh Courses after deletion
      loadCourses();
    } catch (error) {
      console.error("Delete failed:", error.response?.data || error.message);
      alert("Failed to delete the Courses.");
    }
  };




  return (
    <div className="w-full flex flex-col gap-8">
      <div className="w-full flex flex-col gap-4 bg-[#00294B] rounded-md">
        <h2 className="px-4 pt-4 text-2xl font-bold text-white">My Course</h2>
        <div className="w-full flex items-center justify-end gap-4 border-b border-[#22BEFF33] px-4">
          <button
            onClick={() => setShowModal(true)}
            className="py-1 px-4 bg-[#22BEFF] text-black rounded cursor-pointer font-semibold"
          >
            Create
          </button>
        </div>

       <div className="w-full flex flex-col gap-4 p-4 min-h-[20rem]">
          {Courses.length === 0 ? (
            <h4 className="text-xl font-semibold text-white text-center">
              No courses found.
            </h4>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-[#022C4E] text-white rounded-md overflow-hidden">
                <thead>
                  <tr className="bg-[#00406B] text-left">
                    <th className="py-3 px-4">ID</th>
                    <th className="py-3 px-4">Image</th>
                    <th className="py-3 px-4">Name</th>
                    <th className="py-3 px-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Courses.map((cat) => (
                    <tr key={cat.id} className="border-b border-[#1a3c5a]">
                      <td className="py-3 px-4">{cat.id}</td>
                      <td className="py-3 px-4">
                        {cat.image ? (
                         <img src={`${ import.meta.env.VITE_API_BASE_URL
                        }/storage/${cat.image}`}
                        alt={cat.name}
                        className="w-16 h-16 object-cover rounded"
                      />

                        ) : (
                          <span className="text-gray-400">No Image</span>
                        )}
                      </td>
                      <td className="py-3 px-4">{cat.name}</td>
                      <td className="py-3 px-4">
                        <button
                          onClick={() => handleDelete(cat.id)}
                          className="bg-red-600 hover:bg-red-700 text-white py-1 px-3 rounded"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* ✅ Modal */}
        {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[40rem] p-6 relative max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl font-bold mb-4">Create New Course</h3>

            {/* Close Button */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-3 text-xl font-bold text-gray-600 hover:text-black"
            >
              ×
            </button>

            {/* Form */}
            <form onSubmit={handleSubmit} className="space-y-4">
              <input name="name" placeholder="Course Name" onChange={handleChange}  className ="w-full border border-gray-300 p-2 rounded mb-4" />
              <input name="author_name" placeholder="Author Name" onChange={handleChange} className ="w-full border border-gray-300 p-2 rounded mb-4" />
              <input name="current_price" placeholder="Current Price" onChange={handleChange} className ="w-full border border-gray-300 p-2 rounded mb-4" />
              <input name="regular_price" placeholder="Regular Price" onChange={handleChange} className ="w-full border border-gray-300 p-2 rounded mb-4" />
              <input name="course_category_id" placeholder="Category ID" onChange={handleChange} className ="w-full border border-gray-300 p-2 rounded mb-4" />
			  <textarea rows={2} name="seo_description" placeholder="SEO Description"value={form.seo_description} onChange={handleChange} className ="w-full border border-gray-300 p-2 rounded mb-4"/>
              <textarea name="course_details" rows={5} placeholder="Course Details" onChange={handleChange} className ="w-full border border-gray-300 p-2 rounded mb-4" />
			  

			 <span>Image</span>
              <input type="file" onChange={(e) => setImage(e.target.files[0])} className ="w-full border border-gray-300 p-2 rounded mb-4"/>
			  <span>Image Gallery</span>
              <input type="file" multiple onChange={(e) => setImageGallery([...e.target.files])} className ="w-full border border-gray-300 p-2 rounded mb-4"/>

              <h4 className="font-semibold">Content</h4>
              {form.content.map((section, sIdx) => (
                <div key={sIdx} className="bg-gray-50 p-2 rounded mb-2">
                  <input
                    placeholder="Section Title"
                    value={section.title}
                    onChange={(e) => handleContentChange(sIdx, 'title', e.target.value)}
                    className ="w-full border border-gray-300 p-2 rounded mb-4"
                  />
                  {section.items.map((item, iIdx) => (
                    <input
                      key={iIdx}
                      placeholder={`Item ${iIdx + 1}`}
                      value={item}
                      onChange={(e) => handleContentItemChange(sIdx, iIdx, e.target.value)}
                      className ="w-full border border-gray-300 p-2 rounded mb-4"
                    />
                  ))}
                  <button
                    type="button"
                    onClick={() => {
                      const updated = [...form.content];
                      updated[sIdx].items.push('');
                      setForm({ ...form, content: updated });
                    }}
                    className="text-sm text-blue-600"
                  >
                    + Add Item
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => setForm({ ...form, content: [...form.content, { title: '', items: [] }] })}
                className="bg-green-600 text-white px-3 py-1 rounded"
              >
                + Add Section
              </button>

              <h4 className="font-semibold">Content Outcome</h4>
              {form.content_outcome.map((outcome, i) => (
                <input
                  key={i}
                  value={outcome}
                  onChange={(e) => handleOutcomeChange(i, e.target.value)}
                  className ="w-full border border-gray-300 p-2 rounded mb-4"
                  placeholder={`Outcome ${i + 1}`}
                />
              ))}
              <button
                type="button"
                onClick={() => setForm({ ...form, content_outcome: [...form.content_outcome, ''] })}
                className="bg-green-600 text-white px-3 py-1 rounded"
              >
                + Add Outcome
              </button>

              <h4 className="font-semibold">Content Outline</h4>
              {form.content_outline.map((item, i) => (
                <div key={i} className="flex gap-2 mb-2">
                  <input
                    placeholder="Icon"
                    value={item.icon}
                    onChange={(e) => handleOutlineChange(i, 'icon', e.target.value)}
                    className ="w-full border border-gray-300 p-2 rounded mb-4"
                  />
                  <input
                    placeholder="Text"
                    value={item.text}
                    onChange={(e) => handleOutlineChange(i, 'text', e.target.value)}
                    className ="w-full border border-gray-300 p-2 rounded mb-4"
                  />
                </div>
              ))}
              <button
                type="button"
                onClick={() =>
                  setForm({
                    ...form,
                    content_outline: [...form.content_outline, { icon: '', text: '' }],
                  })
                }
                className="bg-green-600 text-white px-3 py-1 rounded"
              >
                + Add Outline
              </button>

              <h4 className="font-semibold">Instructors</h4>
              {form.course_intructor.map((inst, i) => (
                <div key={i} className="grid grid-cols-3 gap-2 mb-2">
                  <input
                    type="file"
                    onChange={(e) => handleInstructorChange(i, 'image', e.target.files[0])}
                  />
                  <input
                    placeholder="Name"
                    value={inst.name}
                    onChange={(e) => handleInstructorChange(i, 'name', e.target.value)}
                    className ="w-full border border-gray-300 p-2 rounded mb-4"
                  />
                  <input
                    placeholder="Education"
                    value={inst.education}
                    onChange={(e) => handleInstructorChange(i, 'education', e.target.value)}
                    className ="w-full border border-gray-300 p-2 rounded mb-4"
                  />
                </div>
              ))}
              <button
                type="button"
                onClick={() =>
                  setForm({
                    ...form,
                    course_intructor: [...form.course_intructor, { image: null, name: '', education: '' }],
                  })
                }
                className="bg-green-600 text-white px-3 py-1 rounded"
              >
                + Add Instructor
              </button>

              <button
                type="submit"
                className={`px-4 py-2 rounded mt-4 w-full ${
                  isSubmitting ? "bg-blue-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
                } text-white`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>

            </form>
          </div>
        </div>
      )}
    </div>
  );
}
